(() => {
  const gallery = document.querySelector('.rfi-phase2');
  if (!gallery) return;
  const cards = [...gallery.querySelectorAll('[data-category]')];
  const gateways = [...gallery.querySelectorAll('[data-rfi-filter]')];
  const status = gallery.querySelector('.rfi-filter-status');
  const reset = gallery.querySelector('[data-rfi-reset]');
  const library = gallery.dataset.libraryMode === 'true';
  const show = (category, focus = false) => {
    const selected = cards.find(card => card.dataset.category === category);
    gallery.dataset.filtered = selected ? 'true' : 'false';
    cards.forEach(card => { card.hidden = selected ? card !== selected : (!library && card.dataset.curated !== 'true'); });
    gateways.forEach(link => { if (selected && link.dataset.rfiFilter === category) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
    reset.hidden = !selected;
    status.textContent = selected ? status.dataset.filterPrefix + ' ' + selected.querySelector('.rfi-eyebrow').textContent.replace(/^\s*\d+\s*\/\s*/, '') : status.dataset.curatedMessage;
    if (selected && focus) selected.focus({preventScroll:true});
  };
  const fromHash = () => { const match = location.hash.match(/^#form-(kitchen|bathroom|bar|office|bedroom|lighting|art-wall-decor)$/); if (match) show(match[1]); };
  document.querySelectorAll('a[href^="#form-"]').forEach(link => link.addEventListener('click', () => {
    const category = link.getAttribute('href').slice(6);
    if (cards.some(card => card.dataset.category === category)) show(category, true);
  }));
  reset.addEventListener('click', () => show(null));
  show(null);
  fromHash();
  window.addEventListener('hashchange', fromHash);
})();
(() => {
  const form = document.getElementById('RayArtCustomDesignInquiry');
  const status = document.getElementById('rfi-inquiry-context');
  if (!form || !status) return;
  const body = form.querySelector('#RFInquiryDescription');
  const department = form.querySelector('#RFInquiryDepartment');
  if (!body || !department) return;
  let lastContext = '';
  let lastDepartment = '';
  let departmentEdited = false;
  department.addEventListener('change', () => { departmentEdited = true; });
  document.querySelectorAll('[data-rfi-inquiry]').forEach((link) => {
    link.addEventListener('click', () => {
      const context = link.dataset.context || '';
      const selected = link.dataset.department || '';
      const canPrefill = !body.value.trim() || body.value === lastContext;
      if (canPrefill && context.length <= body.maxLength) {
        body.value = context;
        lastContext = context;
      }
      if (!departmentEdited && (!department.value || department.value === lastDepartment)) {
        const matching = Array.from(department.options).find((option) => option.value === selected);
        if (matching) {
          department.value = selected;
          lastDepartment = selected;
        }
      }
      status.hidden = false;
      status.textContent = (canPrefill ? status.dataset.selectedMessage : status.dataset.preservedMessage) + ' ' + (link.dataset.concept || '');
    });
  });
})();

